<script lang="ts">
	import star from '../lib/assets/Star.png';
	let a = $state();
	let b = $state();
	let c = $state();
	let d = $state();
	let e = $state();
	let f = $state();
	let nameA = $state('');
	let nameB = $state('');
	let nameC = $state('');
	let nameD = $state('');
	let nameE = $state('');
	let nameF = $state('');
	let picA = $state('');
	let picB = $state('');
	let picC = $state('');
	let picD = $state('');
	let picE = $state('');
	let picF = $state('');

	async function userdata(userid: number[]) {
		const response = await fetch('/api/user', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ userIds: userid })
		});
		if (!response.ok) {
			throw new Error('It failed, sowwwwwyyyy!! OwO');
		}
		let wield = await response.json();
		return wield.data[0].displayName;
	}
	async function avatar(id: number) {
		const response = await fetch('/api/avatar?id=' + id);
		const result = await response.json();
		return result.data[0].imageUrl;
	}
</script>

<header class="head">
	<img src={star} width="75px" alt="Logo.png" />
	<p class="htext">BloodTrader</p>
</header>
<main class="Background">
	<h1 class="Title">Accounts</h1>
	<p class="MBT">
		This section contains information and accounts for trading, select the desired account you want
		to trade with.
	</p>
	<h5 class="WTB">WARNING</h5>
	<p class="MBT">
		Please make sure the account you are trading is offical and matches the other users account in
		worth. Trading with an unoffical account will result in your account being terminated.
	</p>
	<h5 class="HL">Information</h5>
	<div class="list-box">
		<div class="list-box">1) Select the user you want to trade with</div>

		<div class="list-box">
			2) Contact them either on the website or through their provided Discord (if they have it)
		</div>

		<div class="list-box">3) Ensure both you and the other person agree with the trade</div>

		<div class="list-box">
			4) Click the "Notify switch manager" button once you are both ready to initialise the switch
		</div>

		<div class="list-box">
			5) Privately provide the details over Discord or email, such as the account password and
			username
		</div>

		<div class="list-box">
			6) Once both parties have sent their details, the switch manager will change the passwords on
			both accounts, then privately send them to you
		</div>

		<div class="list-box">
			7) Use the given details to make sure you can log in to the account, then change the password
		</div>
	</div>
	<p class="HL">Account List</p>
	<div class="grid">
		<div class="scell">
			{#if nameA}
				<div class="box">
					<img src={picA} alt="Profile picture" width="100" />
					{nameA}
					<button
						class="button"
						onclick={() => {
							nameA = '';
							picA = '';
							a = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={a} />
					<button
						class="button"
						onclick={async () => {
							picA = await avatar(Number(a));
							nameA = await userdata([Number(a)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>

		<div class="scell">
			{#if nameB}
				<div class="box">
					<img src={picB} alt="Profile picture" width="100" />
					{nameB}
					<button
						class="button"
						onclick={() => {
							nameB = '';
							picB = '';
							b = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={b} />
					<button
						class="button"
						onclick={async () => {
							picB = await avatar(Number(b));
							nameB = await userdata([Number(b)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>

		<div class="scell">
			{#if nameC}
				<div class="box">
					<img src={picC} alt="Profile picture" width="100" />
					{nameC}
					<button
						class="button"
						onclick={() => {
							nameC = '';
							picC = '';
							c = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={c} />
					<button
						class="button"
						onclick={async () => {
							picC = await avatar(Number(c));
							nameC = await userdata([Number(c)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>

		<div class="scell">
			{#if nameD}
				<div class="box">
					<img src={picD} alt="Profile picture" width="100" />
					{nameD}
					<button
						class="button"
						onclick={() => {
							nameD = '';
							picD = '';
							d = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={d} />
					<button
						class="button"
						onclick={async () => {
							picD = await avatar(Number(d));
							nameD = await userdata([Number(d)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>

		<div class="scell">
			{#if nameE}
				<div class="box">
					<img src={picE} alt="Profile picture" width="100" />
					{nameE}
					<button
						class="button"
						onclick={() => {
							nameE = '';
							picE = '';
							e = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={e} />
					<button
						class="button"
						onclick={async () => {
							picE = await avatar(Number(e));
							nameE = await userdata([Number(e)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>

		<div class="scell">
			{#if nameF}
				<div class="box">
					<img src={picF} alt="Profile picture" width="100" />
					{nameF}
					<button
						class="button"
						onclick={() => {
							nameF = '';
							picF = '';
							f = '';
						}}>Unregister</button
					>
				</div>
			{:else}
				<div class="box">
					<input class="box" placeholder="User ID" bind:value={f} />
					<button
						class="button"
						onclick={async () => {
							picF = await avatar(Number(f));
							nameF = await userdata([Number(f)]);
						}}>Register</button
					>
				</div>
			{/if}
		</div>
	</div>
</main>
